import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import { toast } from "react-toastify";
import { Inventory_list } from "../../../Redux/Reducer/AuthReducer";
import loadergif from "../../../img/landing/loader123.gif";
import editicon from "../../../img/editicon.png";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const DEFAULT_MEAT_INSTRUCTIONS = `- Defrost meat in fridge (do not keep outside)
- After cutting, soak in water & vinegar then wash`;

// PDF Styles
const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  header: {
    marginBottom: 20,
    borderBottom: "2px solid #591333",
    paddingBottom: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#591333",
    marginBottom: 5,
  },
  dateRange: {
    fontSize: 12,
    color: "#666",
  },
  meatSummarySection: {
    backgroundColor: "#fff3cd",
    padding: 15,
    marginBottom: 20,
    borderRadius: 5,
    border: "1px solid #ffc107",
  },
  meatSummaryTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#856404",
    marginBottom: 10,
  },
  meatSummaryText: {
    fontSize: 11,
    color: "#856404",
    lineHeight: 1.6,
  },
  summaryRow: {
    flexDirection: "row",
    marginBottom: 15,
    gap: 10,
  },
  summaryBox: {
    flex: 1,
    padding: 10,
    borderRadius: 5,
    backgroundColor: "#f8f9fa",
    border: "1px solid #dee2e6",
  },
  summaryLabel: {
    fontSize: 9,
    color: "#666",
    marginBottom: 3,
  },
  summaryValue: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#333",
  },
  table: {
    marginTop: 10,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#591333",
    color: "#fff",
    padding: 8,
    fontWeight: "bold",
    fontSize: 8,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #dee2e6",
    padding: 6,
    fontSize: 8,
  },
  tableRowAlt: {
    flexDirection: "row",
    borderBottom: "1px solid #dee2e6",
    padding: 6,
    fontSize: 8,
    backgroundColor: "#f8f9fa",
  },
  colDay: { width: "10%", paddingRight: 5 },
  colMenu: { width: "15%", paddingRight: 5 },
  colIngredient: { width: "15%", paddingRight: 5 },
  colQtyActual: { width: "10%", paddingRight: 5 },
  colQty100: { width: "10%", paddingRight: 5 },
  colUnit: { width: "8%", paddingRight: 5 },
  colPkgSize: { width: "8%", paddingRight: 5 },
  colVendor: { width: "12%", paddingRight: 5 },
  colNotes: { width: "12%" },
  headerText: {
    color: "#fff",
    fontWeight: "bold",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    textAlign: "center",
    fontSize: 8,
    color: "#999",
    borderTop: "1px solid #dee2e6",
    paddingTop: 10,
  },
  noData: {
    textAlign: "center",
    padding: 20,
    color: "#666",
    fontSize: 12,
  },
});

// PDF Document Component
const GoshBakraPDF = ({ filteredIngredients, meatInstructions, rangeStartDate, rangeEndDate, totalselectedFullThaaliCount, formatDateFn }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={pdfStyles.page}>
      {/* Header */}
      <View style={pdfStyles.header}>
        <Text style={pdfStyles.title}>Meat Summary</Text>
        <Text style={pdfStyles.dateRange}>
          Date Range: {formatDateFn(rangeStartDate)} - {formatDateFn(rangeEndDate)}
        </Text>
      </View>

      {/* Summary Row */}
      <View style={pdfStyles.summaryRow}>
        <View style={pdfStyles.summaryBox}>
          <Text style={pdfStyles.summaryLabel}>Total Meat Items</Text>
          <Text style={pdfStyles.summaryValue}>{filteredIngredients.length || "-"}</Text>
        </View>
        <View style={pdfStyles.summaryBox}>
          <Text style={pdfStyles.summaryLabel}>Total Thaali Count</Text>
          <Text style={pdfStyles.summaryValue}>{totalselectedFullThaaliCount || "-"}</Text>
        </View>
      </View>

      {/* Meat Summary Section */}
      <View style={pdfStyles.meatSummarySection}>
        <Text style={pdfStyles.meatSummaryTitle}>Meat Instructions</Text>
        <Text style={pdfStyles.meatSummaryText}>{meatInstructions}</Text>
      </View>

      {/* Table */}
      <View style={pdfStyles.table}>
        {/* Table Header */}
        <View style={pdfStyles.tableHeader}>
          <Text style={[pdfStyles.colDay, pdfStyles.headerText]}>Day</Text>
          <Text style={[pdfStyles.colMenu, pdfStyles.headerText]}>Menu</Text>
          <Text style={[pdfStyles.colIngredient, pdfStyles.headerText]}>Ingredient Name</Text>
          <Text style={[pdfStyles.colQtyActual, pdfStyles.headerText]}>QTY (Actual)</Text>
          <Text style={[pdfStyles.colQty100, pdfStyles.headerText]}>QTY (100T/10Th)</Text>
          <Text style={[pdfStyles.colUnit, pdfStyles.headerText]}>Unit</Text>
          <Text style={[pdfStyles.colPkgSize, pdfStyles.headerText]}>PKG Size</Text>
          <Text style={[pdfStyles.colVendor, pdfStyles.headerText]}>Vendor</Text>
          <Text style={[pdfStyles.colNotes, pdfStyles.headerText]}>Notes</Text>
        </View>

        {/* Table Body */}
        {filteredIngredients.length > 0 ? (
          filteredIngredients.map((item, index) => (
            <View key={index} style={index % 2 === 0 ? pdfStyles.tableRow : pdfStyles.tableRowAlt}>
              <Text style={pdfStyles.colDay}>{formatDateFn(item?.schedule_day, "true") || "-"}</Text>
              <Text style={pdfStyles.colMenu}>{item?.dish_name || "-"}</Text>
              <Text style={pdfStyles.colIngredient}>{item?.ingredient_name || "-"}</Text>
              <Text style={pdfStyles.colQtyActual}>
                {item?.total_quantity && item?.total_quantity !== 9898
                  ? item?.total_quantity?.toFixed(2)
                  : "-"}
              </Text>
              <Text style={pdfStyles.colQty100}>
                {item?.menu_quantity && item?.total_quantity !== 9898
                  ? item?.menu_quantity
                  : "-"}
              </Text>
              <Text style={pdfStyles.colUnit}>{item?.package_unit || "-"}</Text>
              <Text style={pdfStyles.colPkgSize}>
                {item?.package_size !== "NULL" ? item?.package_size : "-"}
              </Text>
              <Text style={pdfStyles.colVendor}>{item?.vendor_name1 || "-"}</Text>
              <Text style={pdfStyles.colNotes}>
                {item?.ingredient_note !== "NULL" ? item?.ingredient_note : "-"}
              </Text>
            </View>
          ))
        ) : (
          <View style={pdfStyles.noData}>
            <Text>No Meat ingredients found for the selected dates.</Text>
          </View>
        )}
      </View>

      {/* Footer */}
      <Text style={pdfStyles.footer}>
        Generated on {new Date().toLocaleDateString()} | FMB Portal - Meat Summary Report
      </Text>
    </Page>
  </Document>
);

export default function GoshBakraSummary() {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const viewIndata = location.state?.viewInventorydata || [];
  const selectdatelist = location.state?.selectdate || [];
  const selectMiqaatdatelist = location.state?.selectMiqaatdate || [];

  const rangeEndDate = location.state?.rangeEndDate || [];
  const rangeStartDate = location.state?.rangeStartDate || [];
  const currentRangeEndDate = location.state?.currentRangeEndDate || [];

  const weekStartDate = location.state?.weekStartDate || [];
  const weekEndDate = location.state?.weekEndDate || [];

  // Use weekStartDate and weekEndDate for display (user's selected range)
  const displayStartDate = weekStartDate || rangeStartDate;
  const displayEndDate = weekEndDate || rangeEndDate;
  const totalselectedFullThaaliCount = location.state?.totalselectedFullThaaliCount || [];
  const totalselectedMiqaatThaalCount = location.state?.totalselectedMiqaatThaalCount || [];

  const [Ingredientslist, setIngredientsList] = useState(viewIndata);
  const [filteredIngredients, setFilteredIngredients] = useState([]);

  // Meat Instructions state
  const [meatInstructions, setMeatInstructions] = useState(() => {
    const saved = localStorage.getItem("meatInstructions");
    return saved || DEFAULT_MEAT_INSTRUCTIONS;
  });
  const [isEditingInstructions, setIsEditingInstructions] = useState(false);
  const [editedInstructions, setEditedInstructions] = useState(meatInstructions);

  useEffect(() => {
    if (Ingredientslist?.schedule) {
      // Filter only "Gosh (Bakra)" ingredients
      const filtered = Ingredientslist.schedule.filter(
        (item) => item.ingredient_name
      );
      setFilteredIngredients(filtered);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [Ingredientslist]);

  const handleEditInstructions = () => {
    setEditedInstructions(meatInstructions);
    setIsEditingInstructions(true);
  };

  const handleSaveInstructions = () => {
    setMeatInstructions(editedInstructions);
    localStorage.setItem("meatInstructions", editedInstructions);
    setIsEditingInstructions(false);
    toast.success("Meat instructions saved successfully!");
  };

  const handleCancelEdit = () => {
    setEditedInstructions(meatInstructions);
    setIsEditingInstructions(false);
  };

  const handleResetToDefault = () => {
    setEditedInstructions(DEFAULT_MEAT_INSTRUCTIONS);
  };

  var dateName = function (yyyy, mm, dd, full) {
    var monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    var today = new Date(yyyy, mm - 1, dd);
    var dd = today.getDate();
    var mm1 = monthNames[today.getMonth()];
    var fullDate = full === "true" ? mm + "/" + dd + "/" + yyyy : mm1 + " " + dd;
    return fullDate;
  };

  const formatDate = (dateString, full) => {
    if (!dateString) {
      return "";
    }
    const formattedCurrentDate = dateString && dateString?.split("T")[0];
    const dayInformation = dateName(
      formattedCurrentDate?.split("-")[0],
      formattedCurrentDate?.split("-")[1],
      formattedCurrentDate?.split("-")[2],
      full
    );
    return dayInformation;
  };

  // Format date for filename (e.g., "Feb_1")
  const formatDateForFilename = (dateString) => {
    if (!dateString) return "";
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const parts = dateString.split("T")[0].split("-");
    const month = monthNames[parseInt(parts[1], 10) - 1];
    const day = parseInt(parts[2], 10);
    return `${month}_${day}`;
  };

  // Generate PDF filename with date range
  const getPdfFilename = () => {
    const startFormatted = formatDateForFilename(displayStartDate);
    const endFormatted = formatDateForFilename(displayEndDate);
    if (startFormatted && endFormatted) {
      return `Meat_Summary_${startFormatted}_${endFormatted}.pdf`;
    }
    return "Meat_Summary.pdf";
  };

  return (
    <div>
      <Header />
      <div className="main_section exp_in">
        <div className="ExportInventory thali_section">
          <div className="container-fluid">
            <div className="thili_div">
              <div className="Back-page">
                <Link to="/Procurement-Combined">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.175 15.4748L0.225 8.5248C0.141667 8.44147 0.0833335 8.35814 0.0500002 8.2748C0.0166669 8.19147 0 8.0998 0 7.9998C0 7.8998 0.0166669 7.80814 0.0500002 7.7248C0.0833335 7.64147 0.141667 7.55814 0.225 7.4748L7.2 0.499804C7.33333 0.366471 7.5 0.299805 7.7 0.299805C7.9 0.299805 8.075 0.374805 8.225 0.524805C8.375 0.674805 8.45 0.849805 8.45 1.0498C8.45 1.2498 8.375 1.4248 8.225 1.5748L2.55 7.2498H14.95C15.1667 7.2498 15.3458 7.32064 15.4875 7.4623C15.6292 7.60397 15.7 7.78314 15.7 7.9998C15.7 8.21647 15.6292 8.39564 15.4875 8.5373C15.3458 8.67897 15.1667 8.7498 14.95 8.7498H2.55L8.25 14.4498C8.38333 14.5831 8.45 14.7498 8.45 14.9498C8.45 15.1498 8.375 15.3248 8.225 15.4748C8.075 15.6248 7.9 15.6998 7.7 15.6998C7.5 15.6998 7.325 15.6248 7.175 15.4748Z"
                      fill="#777391"
                    />
                  </svg>
                </Link>
                <h1 className="title_heading">
                  &nbsp; &nbsp; &nbsp; Meat Summary
                </h1>
              </div>

              <div className="New_section">
                <button className="btn thali_btn csvbtn">
                  <PDFDownloadLink
                    document={
                      <GoshBakraPDF
                        filteredIngredients={filteredIngredients}
                        meatInstructions={meatInstructions}
                        rangeStartDate={displayStartDate}
                        rangeEndDate={displayEndDate}
                        totalselectedFullThaaliCount={totalselectedFullThaaliCount}
                        formatDateFn={formatDate}
                      />
                    }
                    fileName={getPdfFilename()}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? "Generating PDF..." : "Export PDF"
                    }
                  </PDFDownloadLink>
                </button>
              </div>
            </div>

            <div className="ExportInventory_calender">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <div className="Week_list hover_remove">
                    <div className="week_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="28"
                        viewBox="0 0 24 28"
                        fill="none"
                      >
                        <path
                          d="M6.33333 15.9998C6.04444 15.9998 5.80556 15.9054 5.61667 15.7165C5.42778 15.5276 5.33333 15.2887 5.33333 14.9998C5.33333 14.7109 5.42778 14.4721 5.61667 14.2832C5.80556 14.0943 6.04444 13.9998 6.33333 13.9998H17.6667C17.9556 13.9998 18.1944 14.0943 18.3833 14.2832C18.5722 14.4721 18.6667 14.7109 18.6667 14.9998C18.6667 15.2887 18.5722 15.5276 18.3833 15.7165C18.1944 15.9054 17.9556 15.9998 17.6667 15.9998H6.33333ZM6.33333 21.9998C6.04444 21.9998 5.80556 21.9054 5.61667 21.7165C5.42778 21.5276 5.33333 21.2887 5.33333 20.9998C5.33333 20.7109 5.42778 20.4721 5.61667 20.2832C5.80556 20.0943 6.04444 19.9998 6.33333 19.9998H13.6333C13.9222 19.9998 14.1611 20.0943 14.35 20.2832C14.5389 20.4721 14.6333 20.7109 14.6333 20.9998C14.6333 21.2887 14.5389 21.5276 14.35 21.7165C14.1611 21.9054 13.9222 21.9998 13.6333 21.9998H6.33333ZM2 27.3332C1.46667 27.3332 1 27.1332 0.6 26.7332C0.2 26.3332 0 25.8665 0 25.3332V4.6665C0 4.13317 0.2 3.6665 0.6 3.2665C1 2.8665 1.46667 2.6665 2 2.6665H4.16667V1.73317C4.16667 1.44428 4.27222 1.19428 4.48333 0.983171C4.69444 0.772059 4.95556 0.666504 5.26667 0.666504C5.55556 0.666504 5.80556 0.772059 6.01667 0.983171C6.22778 1.19428 6.33333 1.44428 6.33333 1.73317V2.6665H17.6667V1.73317C17.6667 1.44428 17.7722 1.19428 17.9833 0.983171C18.1944 0.772059 18.4556 0.666504 18.7667 0.666504C19.0556 0.666504 19.3056 0.772059 19.5167 0.983171C19.7278 1.19428 19.8333 1.44428 19.8333 1.73317V2.6665H22C22.5333 2.6665 23 2.8665 23.4 3.2665C23.8 3.6665 24 4.13317 24 4.6665V25.3332C24 25.8665 23.8 26.3332 23.4 26.7332C23 27.1332 22.5333 27.3332 22 27.3332H2ZM2 25.3332H22V10.9998H2V25.3332Z"
                          fill="#957137"
                        />
                      </svg>
                    </div>
                    <div className="week_text">
                      <h4>DATE RANGE</h4>
                      <h1>
                        {formatDate(displayStartDate)}-{formatDate(displayEndDate)}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div className="Week_list INGREDIENTS_Cout hover_remove">
                    <div className="week_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="26"
                        viewBox="0 0 20 26"
                        fill="none"
                      >
                        <path
                          d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                          fill="#591333"
                        />
                      </svg>
                    </div>
                    <div className="week_text">
                      <h4>Total Meat Items</h4>
                      <h1>{filteredIngredients.length || "-"}</h1>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div className="Week_list Thali_Count hover_remove">
                    <div className="week_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <path
                          d="M10.8998 19.3332C11.5887 19.3332 12.1665 19.0943 12.6332 18.6165C13.0998 18.1387 13.3332 17.5665 13.3332 16.8998C13.3332 16.2332 13.0998 15.6609 12.6332 15.1832C12.1665 14.7054 11.5998 14.4665 10.9332 14.4665C10.2443 14.4665 9.66095 14.7054 9.18317 15.1832C8.70539 15.6609 8.4665 16.2332 8.4665 16.8998C8.4665 17.5665 8.70539 18.1387 9.18317 18.6165C9.66095 19.0943 10.2332 19.3332 10.8998 19.3332ZM17.0998 19.3332C17.7665 19.3332 18.3387 19.0943 18.8165 18.6165C19.2943 18.1387 19.5332 17.5665 19.5332 16.8998C19.5332 16.2332 19.2943 15.6609 18.8165 15.1832C18.3387 14.7054 17.7665 14.4665 17.0998 14.4665C16.4332 14.4665 15.8609 14.7054 15.3832 15.1832C14.9054 15.6609 14.6665 16.2332 14.6665 16.8998C14.6665 17.5665 14.9054 18.1387 15.3832 18.6165C15.8609 19.0943 16.4332 19.3332 17.0998 19.3332ZM13.9998 13.0998C14.6665 13.0998 15.2387 12.8665 15.7165 12.3998C16.1943 11.9332 16.4332 11.3554 16.4332 10.6665C16.4332 9.99984 16.1943 9.42762 15.7165 8.94984C15.2387 8.47206 14.6665 8.23317 13.9998 8.23317C13.3332 8.23317 12.7609 8.47206 12.2832 8.94984C11.8054 9.42762 11.5665 9.99984 11.5665 10.6665C11.5665 11.3554 11.8054 11.9332 12.2832 12.3998C12.7609 12.8665 13.3332 13.0998 13.9998 13.0998ZM13.9998 27.3332C12.1776 27.3332 10.4554 26.9832 8.83317 26.2832C7.21095 25.5832 5.79428 24.6276 4.58317 23.4165C3.37206 22.2054 2.4165 20.7887 1.7165 19.1665C1.0165 17.5443 0.666504 15.8109 0.666504 13.9665C0.666504 12.1443 1.0165 10.4221 1.7165 8.79984C2.4165 7.17762 3.37206 5.7665 4.58317 4.5665C5.79428 3.3665 7.21095 2.4165 8.83317 1.7165C10.4554 1.0165 12.1887 0.666504 14.0332 0.666504C15.8554 0.666504 17.5776 1.0165 19.1998 1.7165C20.8221 2.4165 22.2332 3.3665 23.4332 4.5665C24.6332 5.7665 25.5832 7.17762 26.2832 8.79984C26.9832 10.4221 27.3332 12.1554 27.3332 13.9998C27.3332 15.8221 26.9832 17.5443 26.2832 19.1665C25.5832 20.7887 24.6332 22.2054 23.4332 23.4165C22.2332 24.6276 20.8221 25.5832 19.1998 26.2832C17.5776 26.9832 15.8443 27.3332 13.9998 27.3332Z"
                          fill="#1F2F32"
                        />
                      </svg>
                    </div>
                    <div className="week_text">
                      <h4>Total Thaali Count</h4>
                      <h1>{totalselectedFullThaaliCount || "-"}</h1>
                    </div>
                  </div>
                </div>
              </div>

              {/* Meat Summary Block */}
              <div className="row mt-4">
                <div className="col-12">
                  <div
                    className="Week_list hover_remove"
                    style={{
                      backgroundColor: "#fff3cd",
                      border: "1px solid #ffc107",
                      padding: "20px",
                      borderRadius: "8px"
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
                      <div style={{ flex: 1 }}>
                        <h4 style={{
                          color: "#856404",
                          fontWeight: "bold",
                          marginBottom: "15px",
                          fontSize: "18px"
                        }}>
                          Meat Instructions
                        </h4>
                        {isEditingInstructions ? (
                          <div>
                            <textarea
                              className="form-control"
                              rows="5"
                              value={editedInstructions}
                              onChange={(e) => setEditedInstructions(e.target.value)}
                              style={{
                                marginBottom: "10px",
                                fontFamily: "inherit",
                                fontSize: "14px"
                              }}
                            />
                            <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                              <button
                                className="btn thali_btn"
                                onClick={handleSaveInstructions}
                                style={{
                                  backgroundColor: "#591333",
                                  borderColor: "#591333",
                                  color: "#fff"
                                }}
                              >
                                Save
                              </button>
                              <button
                                className="btn thali_btn"
                                onClick={handleCancelEdit}
                                style={{
                                  backgroundColor: "#fff",
                                  borderColor: "#591333",
                                  color: "#591333"
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn thali_btn"
                                onClick={handleResetToDefault}
                                style={{
                                  backgroundColor: "#957137",
                                  borderColor: "#957137",
                                  color: "#fff"
                                }}
                              >
                                Reset to Default
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div style={{
                            color: "#856404",
                            whiteSpace: "pre-line",
                            fontSize: "14px",
                            lineHeight: "1.8"
                          }}>
                            {meatInstructions}
                          </div>
                        )}
                      </div>
                      {!isEditingInstructions && (
                        <button
                          onClick={handleEditInstructions}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "5px"
                          }}
                          title="Edit Instructions"
                        >
                          <img
                            src={editicon}
                            alt="Edit"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="thali_procurement_table_section mt-5">
                {loading ? (
                  <div className="Loading-img">
                    <img src={loadergif} className="" alt="Loading" />
                  </div>
                ) : (
                  <div></div>
                )}
                {filteredIngredients.length > 0 ? (
                  <div className="table table-bordered" id="gosh_bakra_summary_div">
                    <table className="table table-bordered" id="gosh_bakra_summary">
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col">
                            <span className="thali_table">Day</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">Menu</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">Ingredient Name</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">QTY (Actual)</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">QTY (100 Thaalis/10 Thaals)</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">Unit</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">PKG Size</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">Vendor</span>
                          </th>
                          <th scope="col">
                            <span className="thali_table">Notes</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredIngredients.map((items, index) => {
                          const formattedDate = formatDate(items?.schedule_day, "true");
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>{formattedDate || "-"}</li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>{items.dish_name || "-"}</li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>{items.ingredient_name || "-"}</li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>
                                    {items.total_quantity && items.total_quantity !== 9898
                                      ? items?.total_quantity?.toFixed(2)
                                      : "-"}
                                  </li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>
                                    {items.menu_quantity && items.total_quantity !== 9898
                                      ? items.menu_quantity
                                      : "-"}
                                  </li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>{items.package_unit || "-"}</li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>
                                    {items?.package_size !== "NULL"
                                      ? items.package_size
                                      : "-"}
                                  </li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>{items.vendor_name1 || "-"}</li>
                                </ul>
                              </th>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>
                                    {items?.ingredient_note !== "NULL"
                                      ? items.ingredient_note
                                      : "-"}
                                  </li>
                                </ul>
                              </th>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="No_Inventory">
                    {!loading && (
                      <div>
                        <h1>No Meat ingredients found for the selected dates.</h1>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
